import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { fromEvent } from 'rxjs';
import { map, filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ContextService } from '../../context.service';

@Component({
  selector: 'mutara-typehead-option',
  templateUrl: './typehead-option.component.html',
  styleUrls: ['./typehead-option.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TypeheadOptionComponent extends FieldType implements AfterViewInit {

  @ViewChild('inputField', { static: true }) inputSearch: ElementRef | undefined;
  //@ViewChild('valueField', { static: true }) valueField: MatInput;
  @ViewChild('optionList', { static: true }) selectionField: MatAutocomplete | undefined;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger | undefined;

  optionsToDisplay: any = {};
  mapToValue: any;
  groupNames: string[] = [];
  isLoading: boolean = false;
  preventClose: boolean = false;
  canMove: boolean = true;

  constructor(private http: HttpClient, private context: ContextService) {
    super();
  }

  get optionHelper() {
    return this.props.sortableOptions;
  }
  /**
   * Map the input field text to the list of options. This is debounced (700ms) and limited 
   * to a field with more than 2 characters. The resulting list can be grouped and sorted
   * Setup the post load processing of the new options 
   */
  ngAfterViewInit(): void {
    this.context.subscribeTo("canProgress", (value: boolean) => this.canMove = value);
    if (!!this.props.rdv) {
      this.props.rdv?.setDisplay(this.model[this.props.saveField.split('.').pop()]);
    }
    this.props.rdv?.displayValue.subscribe((value: any) => {
      if (!!this.inputSearch?.nativeElement) {
        this.inputSearch.nativeElement.value = value ?? null;
      }
    });
    // When we leave the search field, make sure we can move to the next field (preventClose == false)
    fromEvent(this.inputSearch?.nativeElement, 'blur').subscribe({
      next: (event) => {
        if (this.preventClose) {
          this.inputSearch?.nativeElement.focus();
        }
        this.context.allowNext(!this.preventClose);
      }
    });

    // Use the debounced keyup event (500ms) to create a filtered list from the service
    fromEvent(this.inputSearch?.nativeElement, 'keyup').pipe(
      map((event: any) => {
        let newText = event.target.value;
        if (!!newText && !!this.props.found && !newText.startsWith(this.props.found)) {
          this.props.found = null;
        }
        if (!newText || newText == '') {
          this.formControl.patchValue(null);
          this.props.rdv?.setDisplay(null);
          this.context.allowNext((this.preventClose = false));
          this.autocomplete?.closePanel();
          //this.props.change(this.field, { key: this.field.key, formControl: this.formControl });
        }
        return newText;
      }),
      filter(res => res.length > 2),
      debounceTime(500),
      distinctUntilChanged(),
    ).subscribe({
      error: (err) => {
        console.error(err);
      },
      next: (text: string) => {
        if ((text ?? '') != '') {
          this.optionHelper.lookupValues.term = text;
          this.optionHelper.keyValues.next(this.optionHelper.lookupValues);
        }
      }
    });

    this.props.sortableOptions.obsOptions.subscribe({
      next: (newOptions: any[]) => {
        let text = this.inputSearch?.nativeElement.value;
        this.__processList(newOptions);
        // This is a special case 
        if (!newOptions || newOptions?.length < 1) {
          /// this.formControl.patchValue( text ); // This is the label 
          this.props.description = this.props.notFoundDescription ?? 'Unknown value entered';
          this.formControl.patchValue(this.props.notFoundValue);
          this.props.rdv?.setDisplay(text);
          if ( !!this.props.change ) { this.props?.change(this.field, { value: this.props.notFoundValue }); }
          this.context.allowNext(!(this.preventClose = false));
        } else if (newOptions?.length == 1) {
          //                    console.log('typeahead value %O', results[0].label);
          this.props.found = newOptions[0].label;
          this.valueChange({ option: { value: newOptions[0].value, viewValue: newOptions[0].label ?? '' } });
          this.autocomplete?.closePanel();
        } else {
          // disable tab off and blur close
          this.preventClose = true;
          this.context.allowNext(!this.preventClose);
          this.formControl.setErrors({ 'too-many': true });
          this.autocomplete?.panelClosingActions.subscribe(
            (option) => {
              if (!!this.preventClose && !option) {
                this.props.description = 'Please select an optionfrom the list';
                this.formControl.setErrors({ 'too-many': true });
                setTimeout(() => this.autocomplete?.openPanel(), 50);
              }
              this.formControl.updateValueAndValidity();
            }
          );
          this.formControl.patchValue(this.props.notFoundValue); // No immediate match
          this.props.rdv?.setDisplay(text);
          if ( this.props.change ) {this.props?.change(this.field, { value: this.props.notFoundValue, key: this.field.key, formControl: this.formControl });}
        }
        this.formControl.updateValueAndValidity();

      },
      error: (err : any) => {
        this.isLoading = false;
        console.error('Typeahead returned %O', err);
      }
    });
    if (!!(this.optionHelper.lookupValues.term = this.inputSearch?.nativeElement.value)) {
      this.optionHelper.keyValues.next(this.optionHelper.lookupValues);

    }
  }
  /** 
   * This is called either when a value is selected from the list, 
   * or if the result set returns only 1 value. 
   * 
   * We need to set and send the id and the label, 
   */
  valueChange($event : any) {
    let option = $event.option;
    this.preventClose = false;
    this.props.description = this.props.origDescr;
    // This copies the label to the input field to 
    if ( this.inputSearch?.nativeElement ) this.inputSearch.nativeElement.value = option.label ?? ''; 
    this.formControl.setValue(option.value);
    this.props.rdv?.setDisplay(option.viewValue ?? '');
    if ( !!this.props.change) {this.props.change(this.field, { value: option.value });}
    //this.formControl.updateValueAndValidity();
    this.context.allowNext(!this.preventClose);
  }
  /**
   * Get the current field values for submission to the lookup. 
   * @returns 
   */
  _getKeyValues() {
    return this.props.sortableOptions.lookupValues;
  }
  /**
   * Internal method to convert the results from the service to 
   * group values in the select list
   * 
   * @param results
   */
  __processList(results: any[] = []) {
    let groups : any = {};
    this.groupNames = [];
    this.mapToValue = {};
    // If the results are longer than the display list, do a couple of things
    if (results?.length > 50) {
      this.props.description = 'Too many results, continue typing...';
      results.push({ group: '*** More Values ***', value: '', label: 'continue typing for more values' });
    }

    //this.props.sortableOptions.setOptions(results);
    // Here is where sorting can occur
    results?.forEach(row => {
      if (!row.group) {
        row.group = '';
      }
      this.mapToValue[row.label] = row.value;
      let currentGroup = groups[row.group];
      if (!currentGroup) {
        currentGroup = groups[row.group] = [];
        this.groupNames.push(row.group);
      }
      currentGroup.push(row);
    });
    for (let [groupName, options] of Object.entries(groups)) {
      let optionList: any[] = <any[]>options;
      groups[groupName] = optionList.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    }
    this.optionsToDisplay = groups;
  }
}